<template>
  <meta-overlay v-model="isVisible" append-to-body close-by-mark transition="tra-scaleIn">
    <div class="lecoin-null-bg" @click.stop>
      <div class="title">提示</div>
      <div class="content">乐币不足，无法兑换</div>
      <div class="count">我的乐币：{{ detail?.balance }}</div>
      <div class="footer">
        <div class="confirm" @click="handleConfirm">去兑换乐币</div>
      </div>
    </div>
  </meta-overlay>
</template>

<script lang="ts" setup>
import { ref } from "vue";
import { openNewWeb } from "~/utils/jsb";
import { getPageCenter } from "~/business/alova/methods/goodsPageApi.ts";
import { useRequest } from "alova";

interface Detail {
  balance: number;
  [key: string]: any;
}

const isVisible = ref<boolean>(false);
const detail = ref<Detail | null>(null);
const lecoinPrice = ref<number>(0);

/**
 * 处理兑换乐币操作
 * @returns {Promise<void>}
 */
const handleConfirm = async (): Promise<void> => {
  try {
    const res = await getPageCenter({ codeList: [70] });
    const url = res?.data[0]?.url;
    const jumpUrl = `${url}?source=goods_shop&payment=${lecoinPrice.value}`;
    await openNewWeb("", jumpUrl);
  } catch (error) {
    console.error("兑换乐币失败:", error);
  }
  handleClose();
};

/**
 * 关闭弹窗
 */
const handleClose = (): void => {
  isVisible.value = false;
};

/**
 * 打开弹窗
 * @param {Detail} _detail - 乐币详情
 * @param {number} _lecoinPrice - 乐币价格
 */
const open = (_detail: Detail, _lecoinPrice: number): void => {
  detail.value = _detail;
  lecoinPrice.value = _lecoinPrice;
  isVisible.value = true;
};

defineExpose({
  open,
  close: handleClose
});
</script>

<style scoped lang="scss">
.lecoin-null-bg {
  width: 13.25rem;
  background: #fff;
  position: relative;
  border-radius: 0.5rem;

  .title {
    margin: 0.65rem 0 1.24rem 0;
    text-align: center;
    font-size: 0.685rem;
    font-weight: 600;
  }

  .content {
    color: #000;
    font-size: 0.685rem;
    font-weight: 600;
    text-align: center;
  }

  .count {
    color: #999;
    font-size: 0.515rem;
    text-align: center;
    margin-top: 0.4rem;
  }

  .footer {
    font-size: 0.7rem;
    display: flex;
    justify-content: center;

    .confirm {
      height: 1.68rem;
      line-height: 1.68rem;
      width: 50%;
      background: #ff7210;
      color: #fff;
      text-align: center;
      border-radius: 1rem;
      margin: 1.3rem 0 0.88rem 0;
    }
  }
}
</style>
